import { Order, DateRangeParams } from '../types';
import { getAccessToken } from '../../auth/service/storage.service';
import { API_URL } from '../../common/utils';

/**
 * Obtiene la lista de órdenes por rango de fechas
 * @param params Objeto con fechas de inicio, fin y estado
 * @returns Promesa con la lista de órdenes
 */
export const getOrdersByDateRange = async (params: DateRangeParams): Promise<Order[]> => {
  try {
    const token = getAccessToken();
    
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }
    
    const requestBody: any = {
      startDate: params.startDate,
      endDate: params.endDate
    };

    // Incluir status en la solicitud solo si está definido
    if (params.status) {
      requestBody.status = params.status;
    }
    
    const response = await fetch(`${API_URL}/shopify/orders/date-range`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });
    
    if (!response.ok) {
      throw new Error(`Error al obtener órdenes: ${response.statusText}`);
    }
    
    const data: Order[] = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener órdenes por rango de fechas:', error);
    throw error;
  }
};

/**
 * Elimina una orden por su ID
 * @param id ID de la orden a eliminar
 * @returns Promesa que se resuelve cuando la orden es eliminada
 */
export const deleteOrder = async (id: number): Promise<void> => {
  try {
    const token = getAccessToken();
    
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }
    
    const response = await fetch(`${API_URL}/shopify/orders/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Error al eliminar la orden: ${response.statusText}`);
    }
  } catch (error) {
    console.error('Error al eliminar la orden:', error);
    throw error;
  }
};
